module.exports = __webpack_public_path__ + "static/media/203-Verlassen_ID_3.4da77eda.mp3";